import { render, staticRenderFns } from "./SapBaseRouteList.vue?vue&type=template&id=01457e8e&"
import script from "./SapBaseRouteList.vue?vue&type=script&lang=js&"
export * from "./SapBaseRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports